import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import ObjectViewer from '../Common/ObjectViewer';
import { parseJSON } from '../../utils/helpers';
import Spinner from '../../layout/Spinner';
import { Link, useParams } from 'react-router-dom';

const RunRules = () => {
  const dispatch = useDispatch();
  const { rule_id } = useParams();
  const [ruleId, setRuleId] = useState(rule_id || '');

  const { log, loadingLog } = useSelector((state) => state.general);

  const [defaultStatus, setDefaultStatus] = useState('ACTIVE');

  const runRule = (ruleId) => {
    dispatch(generalSet({ reduxField: 'loadingLog', value: true }));
    dispatch(
      apiAction({
        route: 'actions/runRuleById',
        reduxField: 'log',
        ruleId,
        defaultStatus,
        setLoading: 'loadingLog',
      })
    );
  };

  console.log({ log });
  console.log(parseJSON(log?.jsonData));
  return (
    <>
      {rule_id ? (
        <div className='row d-flex justify-content-left'>
          <div className='col-md-2'>
            <Link className='btn btn-outline-dark' to={`/rule/${rule_id}`}>
              Edit Rule
            </Link>
          </div>
        </div>
      ) : null}
      <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
        <div className='row d-flex justify-content-center border-bottom'>
          <h1>Run Rule</h1>
        </div>
        <div className='row d-flex justify-content-center mt-3'>Select Default Status</div>
        <div className='row d-flex justify-content-center'>
          <div className='col-md-3'>
            <select className='form-control' value={defaultStatus} onChange={(e) => setDefaultStatus(e.target.value)}>
              <option value='ACTIVE'>ACTIVE</option>
              <option value='PAUSED'>PAUSED</option>
            </select>
          </div>
        </div>
        <div className='row d-flex justify-content-center mt-4'>
          <div className='col-md-6'>
            <input
              type='text'
              className='form-control'
              defaultValue={ruleId}
              placeholder='Rule ID...'
              style={{ textAlign: 'center' }}
              onChange={(e) => setRuleId(e.target.value)}
            />
          </div>
        </div>
        {ruleId ? (
          <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
            {loadingLog ? (
              <Spinner />
            ) : (
              <button
                className='btn btn-outline-primary'
                onClick={() => {
                  runRule(ruleId);
                }}
              >
                Run Rule
              </button>
            )}
          </div>
        ) : null}
        {log?._id
          ? (() => {
              const parsedLog = { ...log, jsonData: parseJSON(log.jsonData) };
              return (
                <>
                  <div className='row d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
                    <ObjectViewer data={parsedLog} />
                  </div>
                </>
              );
            })()
          : null}
      </div>
    </>
  );
};

export default RunRules;
